/** SlideDeck
  *
  * A UI controller for paged slidedeck/carousel UI.
  *
  * Required mixins: SnapScroll component
  * Assumes: Equal sized slides, no slide margins
  */
const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');
const SnapScroll = require('../mixins/snapscroll');

var SlideDeck = forgeUiComponent('SlideDeck', {}, function SlideDeckConstructor() {
  var self = this;
  const slides = self.element.querySelector('.SlideDeck-slides');

  const snapScrollEl = self.element.querySelector('.SnapScroll');
  const snapScrollContentEl = self.element.querySelector('.SnapScroll-content');
  const snapScrollOptions = {};
  const snapScroller = new SnapScroll(snapScrollEl, snapScrollContentEl, snapScrollOptions);

  const paginationElement = self.element.querySelector('.SlideDeck-pagination');
  const nextButton = self.element.querySelector('.SlideDeck-nextSlide');
  const previousButton = self.element.querySelector('.SlideDeck-previousSlide');

  Object.defineProperty(this, 'slidesContainer', {
    get: function getSlidesElement() { return slides; }
  });

  Object.defineProperty(this, 'paginationContainer', {
    get: function getPaginationElement() { return paginationElement; }
  });

  Object.defineProperty(this, 'snapScroller', {
    get: function getSlidesElement() { return snapScroller; }
  });

  if (paginationElement) {
    paginationElement.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest && e.target.closest('BUTTON');
      if (!btn) { return; }

      const page = btn.getAttribute('data-target');
      self.snapScroller.goToPage(page);
    });

    self.generatePagination();
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      snapScroller.turnPage(SnapScroll.FORWARDS);
    });
  }

  if (previousButton) {
    previousButton.addEventListener('click', function () {
      snapScroller.turnPage(SnapScroll.BACKWARDS);
    });
  }

  self.element.addEventListener(events.uiScrollSnap, function (e) {
    self.highlightSelectedPage(e.detail.pageIndex);
  });
});

SlideDeck.prototype.generatePagination = function generatePagination() {
  var self = this;
  if (!self.paginationContainer) { return; }

  const pips = document.createDocumentFragment();

  Array.prototype.forEach.call(self.slidesContainer.children, function (child, index) {
    var li = document.createElement('li');
    var button = document.createElement('button');

    li.className = 'SlideDeck-paginationItem';

    button.setAttribute('data-target', index);
    button.className = 'Pip';
    button.textContent = index;

    li.appendChild(button);
    pips.appendChild(li);
  });

  requestAnimationFrame(function () {
    self.paginationContainer.innerHTML = '';
    self.paginationContainer.appendChild(pips);
    self.highlightSelectedPage(0);
  });
};

SlideDeck.prototype.highlightSelectedPage = function highlightSelectedPage(selectedIndex) {
  var self = this;
  if (self.paginationContainer) {
    Array.prototype.forEach.call(self.paginationContainer.querySelectorAll('.Pip'), function (pip, index) {
      requestAnimationFrame(function () {
        pip.classList.toggle('Pip--selected', index === selectedIndex);
      });
    });
  }
};

module.exports = SlideDeck;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/slidedeck.js
// module id = 72
// module chunks = 0